import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as Bootstrap from 'bootstrap';
import GoogleMapsLoader from 'google-maps';

import DialogRegion from '../../lib/views/dialogRegion/dialogRegion';
import DialogRegion2 from '../../lib/views/dialogRegion2/dialogRegion2';
import DialogRouterRegion from '../../lib/views/dialogRouterRegion/dialogRouterRegion';
import DesignRegion from '../../lib/views/designRegion/designRegion';

//import View_CustomSetting from '../views/customSetting/customSetting';
import View_CustomViewEvent from '../views/customViewEvent/customViewEvent';
import View_DialogBox from '../../lib/views/dialogBox/dialogBox';
import * as Entities_Empty from '../../lib/entities/empty';

import language from '../../common/language';

import config from '../../common/config';

//import aaa from '../../common/aaa';

import * as Entities_UserAnalytic from '../entities/userAnalytic';

import * as Entities_PaintStrap from '../entities/paintStrap';
import * as Entities_File from '../entities/file';
import * as Entities_Help from '../entities/help';
import * as Entities_Custom from '../entities/custom';
import * as Entities_CustomItem from '../entities/customItem';
import * as Entities_CustomCrediential from '../entities/customCrediential';
import * as Entities_CustomEventVersion from '../entities/customEventVersion';

import * as Entities_CustomOther from '../entities/customOther';
import * as Entities_CustomSetting from '../entities/customSetting';
import * as Entities_CustomSubscription from '../entities/customSubscription';
//import * as Entities_ConfigSubscription from '../entities/configSubscription';
import * as Entities_CustomSubscriptionJob from '../entities/customSubscriptionJob';
import * as Entities_ConfigSubscriptionJob from '../entities/configSubscriptionJob';
import * as Entities_ConfigSetting from '../entities/configSetting';
import * as Entities_ConfigSchemaModel from '../entities/configSchemaModel';
import * as Entities_CustomImage from '../entities/customImage';
import * as Entities_CustomInfoImage from '../entities/customInfoImage';
import * as Entities_CustomFile from '../entities/customFile';
import * as Entities_CustomInfoFile from '../entities/customInfoFile';
import * as Entities_CustomAd from '../entities/customAd';
import * as Entities_CustomAdImage from '../entities/customAdImage';
import * as Entities_CustomAdBigImage from '../entities/customAdBigImage';
import * as Entities_CustomEvent from '../entities/customEvent';
import * as Entities_CustomEventLive from '../entities/customEventLive';
import * as Entities_CustomEventPush from '../entities/customEventPush';
import * as Entities_CustomEventTemplate from '../entities/customEventTemplate';
import * as Entities_CustomEventTemplateCategory from '../entities/customEventTemplateCategory';
import * as Entities_CustomEventTemplateDefault from '../entities/customEventTemplateDefault';
import * as Entities_CustomModuleTemplate from '../entities/customModuleTemplate';
import * as Entities_CustomQRCode from '../entities/customQRCode';
import * as Entities_CustomWebpage from '../entities/customWebpage';
import * as Entities_CustomWebpageItem from '../entities/customWebpageItem';

import * as Entities_CustomInfopage from '../entities/customInfopage';
import * as Entities_CustomInfopageItem from '../entities/customInfopageItem';

import * as Entities_CustomSchemaModel from '../entities/customSchemaModel';
import * as Entities_CustomFormModel from '../entities/customFormModel';
import * as Entities_CustomProductSheetModel from '../entities/customProductSheetModel';
import * as Entities_ResetUserAnalytic from '../entities/resetUserAnalytic';
import * as Entities_CustomSchemaData from '../entities/customSchemaData';
import * as Entities_CustomSchemaSchema from '../entities/customSchemaSchema';
import * as Entities_CustomFormData from '../entities/customFormData';
import * as Entities_CustomProductSheetData from '../entities/customProductSheetData';
import * as Entities_CustomProductSheetImage from '../entities/customProductSheetImage'

import * as Entities_CustomModule from '../entities/customModule'

import * as Entities_PublicConfigSubscriptionPayment from '../../app/entities/publicConfigSubscriptionPayment';
import * as Entities_PublicPaymentGatewayMD5 from '../../app/entities/PublicPaymentGatewayMD5';
import * as Entities_PublicConfigSubscriptionValidate from '../../app/entities/publicConfigSubscriptionValidate';
import * as Entities_PublicCustom from '../../app/entities/publicCustom';
import * as Entities_PublicShopCart from '../../app/entities/publicShopCart';

import * as Entities_PublicCustomEventAdBig from '../../infopage/entities/publicCustomEventAdBig';

import * as Entities_PublicSetting from '../../common/entities/publicSetting';

import * as Entities_Header from '../../event/entities/header';

import * as Entities_Font from '../../common/entities/font';
import * as Entities_Module from '../../common/entities/module';
import * as Entities_DefaultTemplate from '../../common/entities/defaultTemplate';
import * as Entities_Editor from '../../common/entities/editor';
import * as Entities_Template from '../../common/entities/template';
import * as Entities_Memory from '../entities/memory';

import * as Entities_PublicCustomEventLive from '../../event/entities/publicCustomEventLive';

import DefaultSetting from '../helper/defaultSetting';
import AuthHelper from '../helper/auth';

import Region_Header from '../../common/views/region/header/header';
import Region_HeaderPortal from '../views/region/header/header';

import * as Entities_LanguageSetting from '../../common/entities/languageSetting';
import * as Entities_LanguageValidation from '../../common/entities/languageValidation';

var moment = require('moment');
//import 'regenerator-runtime';
//var ckeditor = require('../../webpageeditor/ckeditor5-build-classic/ckeditor');

import helperSignalr from '../helper/helperSignalr';

//240105 First commit

var WebFont = require('webfontloader');



const oidc = require('../../plugin/oidc-client-ts');


var headerRegion = Marionette.Region.extend({
    el: '#headerRegion'
});

var menuRegion = Marionette.Region.extend({
    el: '#menuRegion'
});

var contentRegion = Marionette.Region.extend({
    el: '#contentRegion'
});

var footerRegion = Marionette.Region.extend({
    el: '#footerRegion'
});

var customMenuRegion = Marionette.Region.extend({
    el: '#customMenuRegion'
});

var editorRegion = Marionette.Region.extend({
    el: '#editorRegion',
    allowMissingEl: true
});

var dialogRegion = DialogRegion.extend({
    el: '#dialogRegion',
    allowMissingEl: true
});

var dialogRegion2 = DialogRegion2.extend({
    el: '#dialogRegion2',
    allowMissingEl: true
});

var dialogRouterRegion = DialogRouterRegion.extend({
    el: '#dialogRouterRegion',
    allowMissingEl: true
});

var renderRegion = Marionette.Region.extend({
    el: '#renderRegion',
    allowMissingEl: true
});

var settingRegion = Marionette.Region.extend({
    el: '#settingRegion',
    allowMissingEl: true
});

var viewEventRegion = Marionette.Region.extend({
    el: '#viewEventRegion',
    allowMissingEl: true
});

var designRegion = DesignRegion.extend({
    el: '#designRegion'
});


var app = module.exports = Marionette.Application.extend({
    regions: {
        headerRegion: headerRegion,
        menuRegion: menuRegion,
        contentRegion: contentRegion,
        customMenuRegion: customMenuRegion,
        editorRegion: editorRegion,
        footerRegion: footerRegion,
        dialogRegion: dialogRegion,
        dialogRegion2: dialogRegion2,
        dialogRouterRegion: dialogRouterRegion,
        renderRegion: renderRegion,
        settingRegion: settingRegion,
        viewEventRegion: viewEventRegion,
        designRegion: designRegion
    },
    onStart: function (options) {
        var self = this;
        $.ajaxSetup({ cache: false });
        language.getDefault();
        var events4us_userCultureName = language.getCookie('events4us_userCultureName');
        $("body").tooltip({ selector: '[data-toggle=tooltip]' });
        var languageCallback = function (resource) {
            window.resources = resource[0].attributes;
            self.setupEntities();
            self.initContent();

            helperSignalr.signalR_init();
        };

        var languageLoginCallback = function (resource) {
            window.resources = resource[0].attributes;
            window.app.router.navigate("#accessTokenLifetime");
            window.app.router.accessTokenLifetime();

            helperSignalr.signalR_init();
        };

        GoogleMapsLoader.LIBRARIES = config.googleMapsLoaderLIBRARIES();
        GoogleMapsLoader.KEY = config.googleMapsLoaderKEY();
        GoogleMapsLoader.load(function (google) {
            AuthHelper.login(self, languageCallback, languageLoginCallback, language, events4us_userCultureName);
        });
    },
    addDays: function (date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    },
    paymentOK: function () {
        var paymentStatus = false;
        var paymentOverdueEnableMenu = false;

        switch (this.entities.collections.customSubscription.fullCollection.models[0].attributes.DineroInvoicePaymentStatus) {
            case 'Draft':
            case 'Booked': paymentStatus = false; break;
            case 'Paid':
            case 'OverPaid': paymentStatus = true; break;
            case 'Overdue': paymentStatus = false; break;
        }

        var array = [];
        paymentOverdueEnableMenu = paymentStatus;
        if (this.entities.collections.customSubscription.fullCollection.length > 1 && paymentStatus == false) {
            //var now = new Date();
            //var utcDateNow = new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), now.getUTCHours(),0,1,0);
            //utcDateNow.setMinutes(0);
            //utcDateNow.setSeconds(1);

            //var utcDate = new Date(this.entities.collections.customSubscription.fullCollection.models[0].attributes.UtcDate);
            //var datePaymentOverdue = this.addDays(utcDate, this.entities.collections.customSubscription.fullCollection.models[0].attributes.PaymentOverdue);
            //var utcDatePaymentOverdue = new Date(datePaymentOverdue.getUTCFullYear(), datePaymentOverdue.getUTCMonth(), datePaymentOverdue.getUTCDate(), datePaymentOverdue.getUTCHours(),0,1,0);

            //if (utcDatePaymentOverdue > utcDateNow) {
            //    paymentOverdue = true;
            //}

            var dateNow = moment();
            dateNow.minutes(0);
            dateNow.seconds(0);
            var utcDateNow = moment([dateNow.utc().year(), dateNow.utc().month(), dateNow.utc().date(), dateNow.utc().hour(), 0, 1]);

            var utcDate = new moment(this.entities.collections.customSubscription.fullCollection.models[0].attributes.UtcDate);
            var utcDatePaymentOverdue = utcDate.add(this.entities.collections.customSubscription.fullCollection.models[0].attributes.PaymentOverdue, 'days');

            if (utcDateNow >= utcDatePaymentOverdue) {
                paymentOverdueEnableMenu = false;
            } else {
                paymentOverdueEnableMenu = true;
            }
        }
        var tmp = { 'paymentStatus': paymentStatus, 'paymentOverdueEnableMenu': paymentOverdueEnableMenu };
        array.push(tmp);

        return array;
    },
    setupEntities: function () {
        var self = this;

        this.mode = 1;

        this.entities = {};
        this.entities.collections = {};
        this.entities.models = {};

        this.entities.models.configSubscription = [];// = new Entities_Empty.Model();
        this.entities.models.configSubscription[0] = {};
        this.entities.models.configSubscription[0].attributes = {};
        this.entities.models.configSubscription[0].attributes.EnableAdvertising = true;
        this.entities.models.configSubscription[0].attributes.EnableQRCode = true;
        this.entities.models.configSubscription[0].attributes.EnableSchemaModel = true;
        this.entities.models.configSubscription[0].attributes.EnableFormModel = true;
        this.entities.models.configSubscription[0].attributes.EnableProductSheetModel = true;
        this.entities.models.configSubscription[0].attributes.EnableService = true;
        this.entities.models.configSubscription[0].attributes.EnablePush = true;
        this.entities.models.configSubscription[0].attributes.EnableInfo = true;
        this.entities.models.configSubscription[0].attributes.EnablePoster = true;
        this.entities.models.configSubscription[0].attributes.EnableTheme = true;
        this.entities.models.configSubscription[0].attributes.EnableFriendlyUrl = true;



        this.entities.collections.informationCollection = new Entities_Empty.Collection();

        this.entities.collections.paintStrap = new Entities_PaintStrap.Collection();
        this.entities.collections.paintStrap.fullCollection.comparator = this.entities.collections.paintStrap.comparator;

        this.entities.collections.help = new Entities_Help.Collection();
        //this.entities.collections.help.fullCollection.comparator = this.entities.collections.help.comparator;

        this.entities.collections.helpPagination = new Entities_Help.CollectionpPagination();
        this.entities.collections.helpPagination.fullCollection.comparator = this.entities.collections.helpPagination.comparator;

        this.entities.collections.file = new Entities_File.Collection();

        this.entities.models.custom = new Entities_Custom.Model();
        this.entities.models.customSubscription = new Entities_CustomSubscription.Model();
        this.entities.models.customItem = new Entities_CustomItem.Model();
        this.entities.models.customEventVersion = new Entities_CustomEventVersion.Model();

        this.entities.models.editorSetting = new Entities_Empty.Model();
        this.entities.models.editorSetting.attributes.DesignMode = false;

        this.entities.collections.userAnalyticCollection = new Entities_UserAnalytic.Collection();

        this.entities.collections.customSetting = new Entities_CustomSetting.Collection();

        this.entities.collections.customOther = new Entities_CustomOther.Collection();
        //this.entities.collections.customSubscription = new Entities_CustomSubscription.Collection();
        //this.entities.collections.configSubscription = new Entities_ConfigSubscription.Collection();
        this.entities.collections.customSubscriptionJob = new Entities_CustomSubscriptionJob.Collection();
        this.entities.collections.configSubscriptionJob = new Entities_ConfigSubscriptionJob.Collection();
        this.entities.collections.configSetting = new Entities_ConfigSetting.Collection();
        this.entities.collections.configSchemaModel = new Entities_ConfigSchemaModel.Collection();
        this.entities.collections.customImage = new Entities_CustomImage.Collection();
        this.entities.collections.customImage.fullCollection.comparator = this.entities.collections.customImage.comparator;
        this.entities.collections.customInfoImage = new Entities_CustomInfoImage.Collection();
        this.entities.collections.customFile = new Entities_CustomFile.Collection();
        this.entities.collections.customFile.fullCollection.comparator = this.entities.collections.customFile.comparator;
        this.entities.collections.customInfoFile = new Entities_CustomInfoFile.Collection();
        this.entities.collections.customAd = new Entities_CustomAd.Collection();
        this.entities.collections.customAdImage = new Entities_CustomAdImage.Collection();
        this.entities.collections.customAdImage.fullCollection.comparator = this.entities.collections.customAdImage.comparator;
        this.entities.collections.customAdBigImage = new Entities_CustomAdBigImage.Collection();
        this.entities.collections.customAdBigImage.fullCollection.comparator = this.entities.collections.customAdBigImage.comparator;
        this.entities.collections.customEvent = new Entities_CustomEvent.Collection();
        this.entities.collections.customEvent.fullCollection.comparator = this.entities.collections.customEvent.comparator;
        this.entities.collections.customEventLive = new Entities_CustomEventLive.Collection();
        this.entities.collections.customEventPush = new Entities_CustomEventPush.Collection();
        this.entities.collections.customEventPush.fullCollection.comparator = this.entities.collections.customEventPush.comparator;
        this.entities.collections.customEventTemplate = new Entities_CustomEventTemplate.Collection();
        this.entities.collections.customEventTemplateCategory = new Entities_CustomEventTemplateCategory.Collection();
        this.entities.collections.customEventTemplateDefault = new Entities_CustomEventTemplateDefault.Collection();

        this.entities.collections.customModuleTemplate = new Entities_CustomModuleTemplate.Collection();
        this.entities.collections.customQRCode = new Entities_CustomQRCode.Collection();
        this.entities.collections.customQRCode.fullCollection.comparator = this.entities.collections.customQRCode.comparator;

        this.entities.collections.customWebpage = new Entities_CustomWebpage.Collection();
        this.entities.collections.customWebpage.fullCollection.comparator = this.entities.collections.customWebpage.comparator;

        this.entities.collections.customInfopage = new Entities_CustomInfopage.Collection();
        this.entities.collections.customInfopage.fullCollection.comparator = this.entities.collections.customInfopage.comparator;

        this.entities.collections.customWebpageItem = new Entities_CustomWebpageItem.Collection();
        this.entities.collections.customInfopageItem = new Entities_CustomInfopageItem.Collection();

        this.entities.collections.customSchemaModel = new Entities_CustomSchemaModel.Collection();
        this.entities.collections.customSchemaModel.fullCollection.comparator = this.entities.collections.customSchemaModel.comparator;
        this.entities.collections.customFormModel = new Entities_CustomFormModel.Collection();
        this.entities.collections.customFormModel.fullCollection.comparator = this.entities.collections.customFormModel.comparator;
        this.entities.collections.customProductSheetModel = new Entities_CustomProductSheetModel.Collection();
        this.entities.collections.customProductSheetModel.fullCollection.comparator = this.entities.collections.customProductSheetModel.comparator;
        this.entities.collections.resetUserAnalytic = new Entities_ResetUserAnalytic.Collection();
        this.entities.collections.customSchemaData = new Entities_CustomSchemaData.Collection();
        this.entities.collections.customSchemaSchema = new Entities_CustomSchemaSchema.Collection();
        this.entities.collections.customFormData = new Entities_CustomFormData.Collection();
        this.entities.collections.customProductSheetData = new Entities_CustomProductSheetData.Collection();
        this.entities.collections.customProductSheetImage = new Entities_CustomProductSheetImage.Collection();

        this.entities.collections.customModule = new Entities_CustomModule.Collection();

        this.entities.collections.publicConfigSubscriptionPayment = new Entities_PublicConfigSubscriptionPayment.Collection();
        this.entities.models.publicPaymentGatewayMD5 = new Entities_PublicPaymentGatewayMD5.Model();
        this.entities.collections.publicConfigSubscriptionValidate = new Entities_PublicConfigSubscriptionValidate.Collection();
        this.entities.collections.publicCustom = new Entities_PublicCustom.Collection();

        this.entities.collections.publicShopCart = new Entities_PublicShopCart.Collection();

        this.entities.collections.headerWebpage = new Entities_Header.Collection();
        this.entities.collections.headerInfopage = new Entities_Header.Collection();

        this.entities.models.publicSetting = new Entities_PublicSetting.Model();
        this.entities.collections.customEventAdBig = new Entities_PublicCustomEventAdBig.Collection();

        this.entities.collections.font = new Entities_Font.Collection();
        this.entities.collections.module = new Entities_Module.Collection();
        this.entities.collections.defaultTemplate = new Entities_DefaultTemplate.Collection();
        this.entities.collections.editor = new Entities_Editor.Collection();
        this.entities.collections.template = new Entities_Template.Collection();

        this.entities.models.publicCustomEventLive = new Entities_PublicCustomEventLive.Model();

        this.entities.collections.languageSetting = new Entities_LanguageSetting.Collection();
        this.entities.collections.languageValidation = new Entities_LanguageValidation.Collection();

        var ExcludeCategoryList = 'Empty,Default,Default module';

        var templateDone = $.Deferred();
        var templateItemDone = $.Deferred();
        var templateCssDone = $.Deferred();

        //window.templateDone = false;
        //window.templateItemDone = false;

        this.entities.models.custom.fetch({
            silent: true,
            wait: true,
            success: function (mode, response) {
                //self.entities.collections.configSubscription.fetch({
                //    silent: true,
                //    wait: true,
                //success: function (mode, response) {

                //    self.entities.collections.customSubscription.fetch({
                //        silent: true,
                //        wait: true,
                //success: function (mode, response) {
                //    var customSubscription = self.entities.collections.customSubscription.fullCollection.where({ id: self.entities.models.custom.attributes.CustomSubscription });
                //    self.entities.models.configSubscription = self.entities.collections.configSubscription.where({ GlobalId: customSubscription[0].attributes.ConfigSubscriptionGlobalId })
                $.when(
                    //self.entities.models.publicSetting.fetch({
                    //    success: function (mode, response) {
                    //    },
                    //    error: function (mode, response) {
                    //    }
                    //}),
                    //self.entities.collections.customSubscriptionJob.fetch({
                    //    success: function (mode, response) {
                    //    },
                    //    error: function (mode, response) {
                    //    }
                    //}),
                    //self.entities.collections.configSubscriptionJob.fetch({
                    //    success: function (mode, response) {
                    //    },
                    //    error: function (mode, response) {
                    //    }
                    //}),
                    self.entities.models.customSubscription.fetch({
                        success: function (mode, response) {
                        },
                        error: function (mode, response) {
                        }
                    }),
                    self.entities.models.customEventVersion.fetch({
                        success: function (mode, response) {
                        },
                        error: function (mode, response) {
                        }
                    }),
                    self.entities.models.customItem.fetch({
                        success: function (mode, response) {
                        },
                        error: function (mode, response) {
                        }
                    }),
                    self.entities.collections.customSetting.fetch({
                        success: function (mode, response) {
                        },
                        error: function (mode, response) {
                        }
                    }),
                    self.entities.collections.paintStrap.fetch({
                        success: function (mode, response) {
                        },
                        error: function (mode, response) {
                        }
                    }),
                    self.entities.collections.customEventAdBig.fetch({
                        silent: true,
                        wait: true,
                        success: function (mode, response) {
                        }
                    }),
                    self.entities.collections.help.fetch({
                        parseField: config.cultureName(),
                        success: function (mode, response) {
                        },
                        error: function (mode, response) {
                        }
                    }),
                    self.entities.collections.file.fetch({
                        success: function (mode, response) {
                        },
                        error: function (mode, response) {
                        }
                    }),
                    //self.entities.collections.customEventPush.fetch({
                    //    readlist : true,
                    //    success: function (mode, response) {
                    //    },
                    //    error: function (mode, response) {
                    //    }
                    //}),
                    self.entities.collections.customEventTemplate.fetch({
                        getVersion: 1,
                        success: function (mode, response) {
                        },
                        error: function (mode, response) {
                        }
                    }),
                    self.entities.collections.customEventTemplateCategory.fetch({
                        ExcludeCategoryList: ExcludeCategoryList,
                        success: function (mode, response) {
                        },
                        error: function (mode, response) {
                        }
                    }),
                    self.entities.collections.customEventTemplateDefault.fetch({
                        success: function (mode, response) {
                        },
                        error: function (mode, response) {
                        }
                    }),
                    //self.entities.collections.customModuleTemplate.fetch({
                    //    success: function (mode, response) {
                    //    },
                    //    error: function (mode, response) {
                    //    }
                    //}),
                    //Do in event
                    //self.entities.collections.customWebpage.fetch({
                    //    DisplayType: 0,
                    //    success: function (mode, response) {
                    //    },
                    //    error: function (mode, response) {
                    //    }
                    //}),
                    /*self.entities.collections.customInfopage.fetch({
                        DisplayType: 1,
                        success: function (mode, response) {
                        },
                        error: function (mode, response) {
                        }
                    }),*/
                    //Do in event
                    //self.entities.collections.customWebpageItem.fetch({
                    //    success: function (mode, response) {
                    //    },
                    //    error: function (mode, response) {
                    //    }
                    //}),
                    /*self.entities.collections.customInfopageItem.fetch({
                        success: function (mode, response) {
                        },
                        error: function (mode, response) {
                        }
                    }),*/
                    //Do in event
                    //self.entities.collections.customQRCode.fetch({
                    //    success: function (mode, response) {
                    //    },
                    //    error: function (mode, response) {
                    //    }
                    //}),
                    //self.entities.collections.configSetting.fetch({
                    //    success: function (mode, response) {
                    //    },
                    //    error: function (mode, response) {
                    //    }
                    //}),
                    //Do in event
                    //self.entities.collections.customSchemaModel.fetch({
                    //    success: function (mode, response) {
                    //    },
                    //    error: function (mode, response) {
                    //    }
                    //}),
                    //Do in event
                    //self.entities.collections.customFormModel.fetch({
                    //    success: function (mode, response) {
                    //    },
                    //    error: function (mode, response) {
                    //    }
                    //}),
                    /*self.entities.collections.customProductSheetModel.fetch({
                        success: function (mode, response) {
                        },
                        error: function (mode, response) {
                        }
                    }),*/
                    self.entities.collections.customImage.fetch({
                        success: function (mode, response) {
                        },
                        error: function (mode, response) {
                        }
                    }),
                    self.entities.collections.customInfoImage.fetch({
                        success: function (mode, response) {
                        },
                        error: function (mode, response) {
                        }
                    }),
                    self.entities.collections.customFile.fetch({
                        success: function (mode, response) {
                        },
                        error: function (mode, response) {
                        }
                    }),
                    //self.entities.collections.customAd.fetch({
                    //    success: function (mode, response) {
                    //    },
                    //    error: function (mode, response) {
                    //    }
                    //}),
                    self.entities.collections.customAdImage.fetch({
                        success: function (mode, response) {
                        },
                        error: function (mode, response) {
                        }
                    }),
                    self.entities.collections.customAdBigImage.fetch({
                        success: function (mode, response) {
                        },
                        error: function (mode, response) {
                        }
                    }),
                    //Do in event
                    //self.entities.collections.customSchemaSchema.fetch({
                    //    success: function (mode, response) {
                    //    },
                    //    error: function (mode, response) {
                    //    }
                    //}),
                    self.entities.collections.customEvent.fetch({
                        success: function (mode, response) {
                        },
                        error: function (mode, response) {
                        }
                    }),
                    //Do in event
                    //self.entities.collections.customModule.fetch({
                    //    success: function (mode, response) {
                    //    },
                    //    error: function (mode, response) {
                    //    }
                    //}),
                    //self.entities.collections.configSchemaModel.fetch({
                    //    success: function (mode, response) {
                    //    },
                    //    error: function (mode, response) {
                    //    }
                    //}),
                    //self.entities.collections.publicConfigSubscriptionPayment.fetch({
                    //    success: function (mode, response) {
                    //    },
                    //    error: function (mode, response) {
                    //    }
                    //}),
                    //self.entities.collections.publicConfigSubscriptionValidate.fetch({
                    //    success: function (mode, response) {

                    //    },
                    //    error: function (mode, response) {
                    //    }
                    //}),
                    self.entities.collections.font.fetch({
                        parseField: config.cultureName(),
                        success: function (mode, response) {
                            self.entities.collections.Font = new Backbone.Collection(response.Font);
                        },
                        error: function (mode, response) {
                        }
                    }),
                    self.entities.collections.languageValidation.fetch({
                        parseField: config.cultureName(),
                        success: function (mode, response) {
                            self.entities.collections.languageValidation_Collection = new Entities_Memory.Collection(self.entities.collections.languageValidation.models[0].attributes.Collection);

                            var i = 0;
                        },
                        error: function (mode, response) {
                            var i = 0;
                        }
                    }),
                    self.entities.collections.languageValidation.fetch({
                        parseField: config.cultureName(),
                        success: function (mode, response) {
                            self.entities.collections.languageValidation_Collection = new Entities_Memory.Collection(self.entities.collections.languageValidation.models[0].attributes.Collection);

                            var i = 0;
                        },
                        error: function (mode, response) {
                            var i = 0;
                        }
                    }),
                    self.entities.collections.languageSetting.fetch({
                        success: function (mode, response) {
                        },
                        error: function (mode, response) {
                        }
                    }),
                    self.entities.collections.module.fetch({
                        parseField: config.cultureName(),
                        success: function (mode, response) {
                            window.module = response[config.cultureName()];

                            self.entities.collections.Module = new Backbone.Collection(window.module.Module);
                            //self.entities.collections.ModuleSetting = new Backbone.Collection(window.module.ModuleSetting);

                            self.entities.collections.AppFrame_BackGroundType = new Backbone.Collection(window.module.AppFrame_BackGroundType);
                            self.entities.collections.AppFrame_ForeGroundType = new Backbone.Collection(window.module.AppFrame_ForeGroundType);
                            self.entities.collections.BorderColorType = new Backbone.Collection(window.module.BorderColorType);
                            self.entities.collections.ModuleBackGroundType = new Backbone.Collection(window.module.ModuleBackGroundType);
                            self.entities.collections.ModuleBackGroundImagePosition = new Backbone.Collection(window.module.ModuleBackGroundImagePosition);
                            self.entities.collections.ModuleBorderStyle = new Backbone.Collection(window.module.ModuleBorderStyle);
                            self.entities.collections.AppBackGroundColorType = new Backbone.Collection(window.module.AppBackGroundColorType);
                            self.entities.collections.AppMenuColorBackGroundType = new Backbone.Collection(window.module.AppMenuColorBackGroundType);
                            self.entities.collections.AppMenuColorForeGroundType = new Backbone.Collection(window.module.AppMenuColorForeGroundType);
                            self.entities.collections.GridBackGroundType = new Backbone.Collection(window.module.GridBackGroundType);
                            self.entities.collections.GridFontType = new Backbone.Collection(window.module.GridFontType);
                            self.entities.collections.GridFontColorType = new Backbone.Collection(window.module.GridFontColorType);
                            self.entities.collections.InfoFontType = new Backbone.Collection(window.module.InfoFontType);
                            self.entities.collections.AppFontType = new Backbone.Collection(window.module.AppFontType);
                            self.entities.collections.InfoFontColorType = new Backbone.Collection(window.module.InfoFontColorType);
                            self.entities.collections.AppFontColorType = new Backbone.Collection(window.module.AppFontColorType);
                            self.entities.collections.FontStyle = new Backbone.Collection(window.module.FontStyle);
                            self.entities.collections.LineHeight = new Backbone.Collection(window.module.LineHeight);
                            self.entities.collections.TextAlign = new Backbone.Collection(window.module.TextAlign);
                            //self.entities.collections.Font = new Backbone.Collection(window.module.Font);
                            self.entities.models.InfoPageSetting = new Entities_Memory.Model(window.module.InfoPageSetting);
                            self.entities.collections.WeatherTemplate = new Backbone.Collection(window.module.WeatherTemplate);
                            self.entities.collections.WeatherForecast = new Backbone.Collection(window.module.WeatherForecast);
                            self.entities.collections.WeatherUnit = new Backbone.Collection(window.module.WeatherUnit);
                            self.entities.collections.PictureSlideLabelAnimation = new Backbone.Collection(window.module.PictureSlideLabelAnimation);
                            self.entities.collections.PictureSlideAnimation = new Backbone.Collection(window.module.PictureSlideAnimation);
                            self.entities.collections.HtmlSlideAnimationGroup = new Backbone.Collection(window.module.HtmlSlideAnimationGroup);
                            self.entities.collections.HtmlSlideAnimation = new Backbone.Collection(window.module.HtmlSlideAnimation);
                            self.entities.collections.FeedProvider = new Backbone.Collection(window.module.FeedProvider);
                            self.entities.collections.FeedCount = new Backbone.Collection(window.module.FeedCount);
                            self.entities.collections.DigitalClockDateFormat = new Backbone.Collection(window.module.DigitalClockDateFormat);
                            self.entities.collections.DigitalClockHelper = new Backbone.Collection(window.module.DigitalClockHelper);

                            self.entities.collections.QRCodeFontStyle = new Backbone.Collection(window.module.QRCodeFontStyle);

                            self.entities.collections.GridMenuType = new Backbone.Collection(window.module.GridMenuType);

                            self.entities.collections.Category = new Backbone.Collection(window.module.Category);
                        },
                        error: function (mode, response) {
                        }
                    }),
                    self.entities.collections.defaultTemplate.fetch({
                        parseField: config.cultureName(),
                        success: function (mode, response) {
                            var defaultTemplate = response[config.cultureName()];

                            self.entities.collections.DefaultTemplate = new Backbone.Collection(defaultTemplate.Collection);
                        },
                        error: function (mode, response) {
                        }
                    }),

                    self.entities.collections.editor.fetch({
                        success: function (mode, response) {
                            window.editor = response;
                            self.entities.collections.DiasListCollection = new Backbone.Collection(window.editor.Collection);
                        },
                        error: function (mode, response) {
                        }
                    }),
                    self.entities.collections.template.fetch({
                        success: function (mode, response) {
                            //window.editor = response;
                            self.entities.collections.Template = new Backbone.Collection(response.Collection);

                            self.entities.collections.Template.forEach(function (entry) {
                                if (entry.attributes.Template.length > 0) {
                                    $.get(entry.attributes.Template, function (html_string) {
                                        entry.attributes.TemplateBase64 = window.btoa(html_string);

                                        var allfetch = true;
                                        self.entities.collections.Template.forEach(function (entry) {
                                            if (entry.attributes.TemplateBase64.length == 0) {
                                                allfetch = false;
                                            }
                                        });

                                        if (allfetch) {
                                            templateDone.resolve(true);
                                        }
                                    }, 'html');
                                }
                            });

                            self.entities.collections.Template.forEach(function (entry) {
                                if (entry.attributes.TemplateItem.length > 0) {
                                    $.get(entry.attributes.TemplateItem, function (html_string) {
                                        entry.attributes.TemplateItemBase64 = window.btoa(html_string);

                                        var allfetch = true;
                                        self.entities.collections.Template.forEach(function (entry) {
                                            if (entry.attributes.TemplateItemBase64.length == 0) {
                                                allfetch = false;
                                            }
                                        });

                                        if (allfetch) {
                                            templateItemDone.resolve(true);
                                        }

                                    }, 'html');
                                }
                            });

                            var bust = new Date().getTime();

                            var cssFile = '/template/css/template.css?bust=' + bust;

                            var css = $('<link/>', {
                                rel: 'stylesheet',
                                type: 'text/css',
                                href: cssFile
                            }).data('data-css', 'form_css');

                            css.appendTo('head');
                            css[0].setAttribute('data-css', 'form_css');
                            css.load(function () {
                                templateCssDone.resolve(true);
                            }).attr('href', cssFile);
                        },
                        error: function (mode, response) {
                        }
                    }),
                    templateDone,
                    templateItemDone,
                    templateCssDone
                ).done(function () {
                    var callback = function (succes) {
                        if (succes == true) {

                            self.loadGoogleFont();

                            DefaultSetting.SetStartUp();

                            self.initSetting();

                            Backbone.history.start();

                            //var paymentOK = self.paymentOK();

                            self.setupCKEditor();

                            // if (paymentOK[0].paymentStatus) {


                            if (self.entities.models.customSubscription.attributes.Status != 'active') {
                                self.firstRoute('#customSubscriptionStripe', false, false);
                            }
                            else {
                                self.firstRoute('#custom', false, true);
                            }

                            
                            //self.firstRoute('#customWebpageEditItem', false, true);
                            //self.setupHeader();
                            //} else {
                            //    self.firstRoute('#customSubscription', false, paymentOK[0].paymentOverdueEnableMenu);
                            //    self.setupHeader();
                            //}

                            $('html').css('overflow', 'auto');
                        } else {
                            DefaultSetting.checkCustomSetting(self, self.waitingDefaultSetting, callback);
                        }
                    }

                    DefaultSetting.checkCustomSetting(self, self.waitingDefaultSetting, callback);

                    //       });
                    //},
                    //error: function (mode, response) {
                    //}
                    // });
                    //},
                    //error: function (mode, response) {
                    //}
                });
            },
            error: function (mode, response) {
                var dialogBoxModel = new Entities_Empty.Model();
                dialogBoxModel.attributes.Title = resources.X100704;
                dialogBoxModel.attributes.Text = resources.X100734;
                dialogBoxModel.attributes.Button = resources.X100279;

                var dialogBox = new View_DialogBox({ model: dialogBoxModel, parent: self });
                var callback2 = function () {
                    self.stopListening(dialogBox, "dialog:okclicked", callback2);

                    AuthHelper.logout(this);

                    //if (this.mgr !== undefined && this.mgr.profile !== undefined) {
                    //    mgr.redirectForLogout();
                    //} else {
                    //    var location = '';
                    //    switch (window.location.host) {
                    //        case 'localhost:7072': location = window.location.protocol + '//' + 'localhost:7072/index.html'; break;
                    //        case 'events4usproduction.azurewebsites.net': location = window.location.protocol + '//' + 'events4usproduction.azurewebsites.net/index.html'; break;
                    //        case 'events4us.net': location = window.location.protocol + '//' + 'events4us.net/index.html'; break;
                    //        case 'www.events4us.net': location = window.location.protocol + '//' + 'www.events4us.net/index.html'; break;
                    //        case 'events4us.dk': location = window.location.protocol + '//' + 'events4us.dk/index.html'; break;
                    //        case 'www.events4us.dk': location = window.location.protocol + '//' + 'www.events4us.dk/index.html'; break;
                    //        case 'events4usproduction-test.azurewebsites.net': location = window.location.protocol + '//' + 'events4usproduction-test.azurewebsites.net/index.html'; break;
                    //        case 'test.events4us.net': location = window.location.protocol + '//' + 'test.events4us.net/index.html'; break;
                    //    }
                    //    window.location.href = location;
                    //}
                }
                self.listenTo(dialogBox, "dialog:okclicked", callback2);
                self.dialogRegion.show(dialogBox);
            }
        });
    },
    firstRoute: function (route, validate, enableMenu) {
        if (route != '#waitingDefaultSetting') {
            if (validate) {
                var modelErrors = window.app.entities.models.custom.validateNoBackbone(this.entities.models.custom.attributes);
                if (modelErrors) {
                    route = '#custom';
                }
                else {
                    route = '#customEventCounter';
                }
            }

            route = "#customEvent";
            //route = "#customEventEditItem";
            //route = "#customInfopageEditItem";
        }

        switch (route) {
            case '#waitingDefaultSetting':
                window.app.router.navigate("#waitingDefaultSetting");
                window.app.router.waitingDefaultSetting();
                break;
            case '#waiting':
                window.app.router.navigate("#waiting");
                window.app.router.waiting();
                break;
            case '#custom':
                window.app.router.navigate("#custom");
                window.app.router.custom();
                break;
            case '#customEventCounter':
                window.app.router.navigate("#customEventCounter?id=-1");
                window.app.router.customEventCounter(-1);
                break;
            case '#customSubscription':
                window.app.router.navigate("#customSubscription");
                window.app.router.customSubscription(enableMenu);
                break;
            case '#customSubscriptionStripe':
                window.app.router.navigate("#customSubscriptionStripe");
                window.app.router.customSubscriptionStripe(enableMenu);
                break;
            case '#customWebpageEditItem':
                window.app.router.navigate("#customWebpageEditItem");
                window.app.router.customWebpageEditItem(24);
                break;

            case '#customEventEditItem':
                var scroll = $(document).scrollTop();
                var model = window.app.entities.collections.customEvent.fullCollection.models[0];
                window.app.router.navigate("#customEventEditItem/" + model.attributes.id);
                window.app.router.customEventEditItem(model.attributes.id, scroll, 0, 1, true, false);
                break;
            case '#customEvent':
                var scroll = $(document).scrollTop();

                window.app.router.navigate("#customEvent");
                window.app.router.customEvent();
                break;

            case '#customInfopageEditItem':
                var scroll = $(document).scrollTop();
                var model = window.app.entities.collections.customEvent.fullCollection.models[0];

                window.app.router.navigate("#customInfopageEditItem");
                //window.app.router.customInfopageEditItem(model.attributes.Infopage, model.attributes.id, scroll, 0);

                var customModuleModel = window.app.entities.collections.customModule.where({ EventId: model.attributes.id, ModuleType: 1 })[0];

                window.app.router.customInfopageEditItem(customModuleModel.attributes.id, model.attributes.id);
                break;

            case '#test':
                var i = 0;
                var total = 0;
                var timerId = 0;

                timerId = window.setInterval(function () {
                    switch (i) {
                        case 0: window.app.router.customEventCounter(); break;
                        //case 1: window.app.router.customEventPush(); break;
                        case 2: window.app.router.customSchemaData(); break;
                        case 3: window.app.router.customEvent(); break;
                        case 4: window.app.router.customEventEditItem(30); break;
                        case 5: window.app.router.customEventTemplate(); break;
                        case 6: window.app.router.customWebpage(); break;
                        case 7: window.app.router.customWebpageEditItem(6); break;
                        case 8: window.app.router.customQRCode(); break;
                        case 9: window.app.router.customQRCodeEditItem(15); break;
                        case 10: window.app.router.customSchemaModel(); break;
                        case 11: window.app.router.customSchemaModelEditItem(1); break;
                        case 12: window.app.router.customImage(); break;
                        case 13: window.app.router.customFile(); break;
                        case 14: window.app.router.custom(); break;
                        case 15: window.app.router.customSubscription(); break;
                    }
                    i++;
                    if (i > 15) {
                        i = 0;
                        total++;
                    }
                    if (total > 30) {
                        clearInterval(timerId);
                    }
                }, 4000);

                break;

        }
    },
    loadGoogleFont: function () {
        var fonts = [];

        this.entities.collections.Font.forEach(function (entry) {
            if (entry.attributes.data_font_style.length > 0)
                fonts.push(entry.attributes.data_font_family + ':' + entry.attributes.data_font_style);
            else
                fonts.push(entry.attributes.data_font_family);
        });

        WebFont.load({
            google: {
                families: fonts
            }
        });
    },
    initContent: function () {
        $.valHooks.textarea = {
            get: function (elem) {
                return elem.value.replace(/\r?\n/g, "\r\n");
            }
        };

        var self = this;
        this.firstRoute("#waitingDefaultSetting", false, false);
        //this.firstRoute("#test", false);
    },
    initSetting: function () {
        //var customSetting = new View_CustomSetting({ collection: self.app.entities.collections.customSetting, app : self.app });
        //self.app.settingRegion.show(customSetting);

        //self.app.entities.collections.customEvent.models[2].attributes.Active = false;
        var tmpModel = new Entities_Empty.Model();
        tmpModel.attributes.Render = false;

        var customViewEvent = new View_CustomViewEvent({ model: tmpModel, collection: self.app.entities.collections.customEvent.fullCollection, app: self.app });
        //self.app.viewEventRegion.show(customViewEvent);
    },
    setupHeader: function () {
        localStorage.setItem('events4usUser_FirstName', this.entities.models.custom.attributes.FirstName);
        localStorage.setItem('events4usUser_AttPerson', this.entities.models.custom.attributes.AttPerson);
        localStorage.setItem('events4usUser_Organisation', this.entities.models.custom.attributes.Organisation);

        this.headerRegion.show(new Region_HeaderPortal({ app: this }));
        var userChannel = Backbone.Radio.channel('app');
        /*userChannel.trigger('Region_Header:setLoginName');*/
    },
    setupCKEditor: function () {
        //CKEDITOR.disableAutoInline = true;

        //CKEDITOR.stylesSet.add('my_styles',
        //    [
        //        // Block-level styles
        //        { name: 'Header 1', element: 'h1', styles: { 'color': 'Blue' } },
        //        { name: 'Red Title', element: 'h2', styles: { 'color': 'Red' } },
        //        { name: 'Red Title', element: 'p', styles: { 'color': 'Red' } }
        //        // Inline styles
        //        /*{ name: 'CSS Style', element: 'span', attributes: { 'class': my_styles } },
        //        { name: 'Marker: Yellow', element: 'span', styles: { 'background-color': 'Yellow' } }*/
        //    ]);
    },
    renderInformation: function (informationCollection) {
        var counter = 1;
        this.running = true;
        var self = this;
        var customSetting = this.entities.collections.customSetting.where({ Name: 'ShowInformation' });

        informationCollection.informationCollection.forEach(function (entry) {
            var show = true;

            if ((self.entities.collections.informationCollection.where({ toastType: entry.attributes.toastType, header: entry.attributes.header, Information: entry.attributes.Information }).length <= 0)) {
                if (entry.attributes.toastType != 3) {
                    self.entities.collections.informationCollection.add(entry);
                }

                if (entry.attributes.toastType == 1 && customSetting[0].attributes.Value == '0') {
                    show = false;
                }

                if (show) {
                    entry.attributes.timeout_id = setTimeout(function () {
                        if (self.running) {
                            clearTimeout(entry.attributes.timeout_id);
                            $.fn.showToast(entry.attributes.toastType, entry.attributes.header, entry.attributes.Information);
                        }
                    }, counter * 1000);
                    counter++;
                }
            }
        });

        //informationCollection.informationCollection.forEach(function (entry) {
        //    entry.attributes.timeout_id = setTimeout(function () {
        //        if (self.running) {
        //            clearTimeout(entry.attributes.timeout_id);
        //            $.fn.showToast(entry.attributes.toastType, entry.attributes.header, entry.attributes.Information);
        //        }
        //    }, counter * 1000);
        //    counter++;
        //});
    },
    iconArrowsAlt: function () {
        var timerId = window.setInterval(function () {
            var userChannel = Backbone.Radio.channel('app');
            userChannel.trigger('customInfopageEditItemTopbar:setZoom');
            clearInterval(timerId);
        }, 1000);
    }
});



